/**
 * Hook for fetching credentials/license data for export report
 */

import { useQuery } from '@tanstack/react-query'
import axios, { pluckData } from 'src/utilities/http-client'
import type { CredentialsExportItem } from '../types'

/**
 * Query key factory for credentials data
 */
export let credentialsQueryKeys = {
  all: ['v4-dashboard-credentials'] as const,
  byService: (linkedServiceID: string) =>
    [...credentialsQueryKeys.all, 'service', linkedServiceID] as const,
}

/**
 * Hook to fetch credentials data for a specific linked service
 */
export function useCredentialsData(linkedServiceID: string, enabled = true) {
  return useQuery({
    queryKey: credentialsQueryKeys.byService(linkedServiceID),
    queryFn: async (): Promise<CredentialsExportItem[]> => {
      if (!linkedServiceID) {
        return []
      }

      let url = `/api/manage/dashboard/credentials?linkedServiceID=${encodeURIComponent(linkedServiceID)}`

      return axios.get<CredentialsExportItem[]>(url).then(pluckData)
    },
    enabled: enabled && Boolean(linkedServiceID),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
